var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-box"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.heading))]),(_vm.inactive)?_c('p',{staticClass:"no-number"},[_vm._v("Not Available")]):_vm._e(),_c('p',{staticClass:"number"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }